
import request from './api';

export const selectTestData = (params, opts) =>
    request('/api-study/practise/paper', params, {
        ...opts,
        method: 'post'
    });
export const selectTestDataNew = (params, opts) =>
    request('/api-teachingaffair/globalExam/practise/paper', params, {
        ...opts,
        method: 'post'
    });
    
export const saveAnswer = (params, opts) =>
    request('/api-study/save/exam/record', params, {
        ...opts,
        method: 'post'
    });
export const saveAnswerNew = (params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/saveAnswer', params, {
        ...opts,
        method: 'post'
    });
    
export const preAnswer = (params, opts) =>
    request('/api-study/query/exam/question/answer', params, {
        ...opts,
        method: 'post'
    });
export const preAnswerNew = (params, opts) =>
    request('/api-teachingaffair/globalExamAnswerRecord/getQuestionAnswer', params, {
        ...opts,
        method: 'post'
    });
export default {
  selectTestData,
  selectTestDataNew,
  saveAnswer,
  saveAnswerNew,
  preAnswer,
  preAnswerNew,

}



// WEBPACK FOOTER //
// ./src/api/exam.js